import { render, staticRenderFns } from "./icon-underlined.vue?vue&type=template&id=820bebe6"
import script from "./icon-underlined.vue?vue&type=script&lang=js"
export * from "./icon-underlined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports